/**
 * multiOrganizationCaseDataManagement-stackを利用する時はこのコードを組み込んでください。基本的にコピペでOKです。
 */

import {prepareTable, getTable} from './multiOrgCaseBasedDataManage';
import {MultiOrgCaseDataManage} from './multiOrgCaseBasedDataManageClass';
import {getDriver, initMultiOrganizationCaseDataWithDummyDriver} from './dummyDrivers/initMultiOrgCaseDataDriver';

let tableName = '';

const getTableName = () => tableName;
const setTableName = (name: string) => tableName = name;  // テストコードでdummyDriverを使う時に利用（initMultiOrganizationCaseDataWithDummyDriverをテストコードで直接呼ぶ時）
const getMultiOrgCaseDataTable = async (): Promise<MultiOrgCaseDataManage> => await getTable(tableName);

const initSingleTable = async (name: string, useDummyDriver: boolean, localStorage=false) => {
  tableName = name;
  if (useDummyDriver) {
    await initMultiOrganizationCaseDataWithDummyDriver(tableName, '', 86400, localStorage);  // TODO: 本番では削除する
  } else {
    const tbl = await prepareTable(tableName, undefined, undefined, localStorage);
    tbl.setRemoveLeadTime(86400*30);
  }
};

const tableClear = async () => {
  await(await getMultiOrgCaseDataTable()).flush();
  if (getDriver(tableName)) await getDriver(tableName).allLocalTableClear();
};

export {getTableName, setTableName, initSingleTable, getMultiOrgCaseDataTable, tableClear};
